import { render, staticRenderFns } from "./WriteAdd.vue?vue&type=template&id=77708960&"
import script from "./WriteAdd.vue?vue&type=script&lang=js&"
export * from "./WriteAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports